export default "__VITE_ASSET__CaAr9Wpe__"